import React, { Component } from 'react'
import styles from './style.module.less'
import { observer, inject } from 'mobx-react'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'

@inject('stepTwoStore')
@observer
export default class extends Component {
  render() {
    const { anchor, changeAnchor } = this.props.stepTwoStore
    const activeKey = anchor.find(item => item.active).key

    return (
      <div className={styles.wrapper}>
        {/* <Tabs defaultActiveKey="1" onChange={()=>{}}>
          <TabPane tab="图文介绍" key="1" />
          <TabPane tab="服务内容" key="2" />
          <TabPane tab="相关案例" key="3" />
        </Tabs> */}
        <div className={styles.header}>
          {anchor.map(({ active, key, text }, index) => {
            return (
              <div
                className={`${active ? styles.active : styles.common}`}
                styles={{
                  borderLeft: key === 2 ? '1px solid #CCCCCC' : 'none',
                  borderRight: key === 2 ? '1px solid #CCCCCC' : 'none'
                }}
                key={key}
                onClick={() => changeAnchor(index + 1)}
              >
                {text}
              </div>
            )
          })}
        </div>
        {activeKey === 1 && <Tab1 />}
        {activeKey === 2 && <Tab2 />}
        {activeKey === 3 && <Tab3 />}
      </div>
    )
  }
}
